import { render, staticRenderFns } from "./SingularityRightPanel.vue?vue&type=template&id=1909e2d1&"
import script from "./SingularityRightPanel.vue?vue&type=script&lang=ts&"
export * from "./SingularityRightPanel.vue?vue&type=script&lang=ts&"
import style0 from "./SingularityRightPanel.vue?vue&type=style&index=0&id=1909e2d1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports